import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';
import b2cauth from '@kdpw/msal-b2c-react';
import 'react-vis/dist/style.css';


ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
